import MicroModal from 'micromodal';
import Headroom from 'headroom.js';
import InView from '../InView';
import Nav from '../Nav';

export default {
  init() {
    console.log('common::init');

    const header = document.querySelector('.header');

    if (header) {
      const headroom = new Headroom(header);
      headroom.init();
      Nav();
    }

    InView('.reveal');

    MicroModal.init({
      awaitCloseAnimation: true,
      disableScroll: true,
      onShow: (modal) => {
        window.dispatchEvent(
          new CustomEvent('ModalOpen', { detail: { modal } })
        );
      },
    });

    if (document.querySelector('[data-video]')) {
      import('../VideoBlock').then((VideoBlock) => {
        VideoBlock.default();
      });
    }

    if (document.querySelector('[data-carousel]')) {
      import('../carousel').then((Carousel) => {
        Carousel.default();
      });
    }

    if (document.querySelector('[data-form]')) {
      import('../Form').then((FormBlock) => {
        FormBlock.default();
      });
    }

    if (document.querySelector('.news-filter')) {
      import('../NewsFilter').then((NewsFilter) => {
        NewsFilter.default();
      });
    }

    if (document.querySelector('.programme-nav-select')) {
      import('../ProgrammeNavSelect').then((ProgrammeNavSelect) => {
        ProgrammeNavSelect.default();
      });
    }

    if (document.querySelector('.resource-search-reset')) {
      import('../ResourceSearchReset').then((ResourceSearchReset) => {
        ResourceSearchReset.default();
      });
    }

    if (document.querySelector('.team-filter')) {
      import('../TeamFilter').then((TeamFilter) => {
        const team_list = document.getElementById('team-list');
        new TeamFilter.default(team_list);
      });
    }

    if (document.querySelector('[data-acn-nav]')) {
      import('../AcnNav').then((AcnNav) => {
        new AcnNav.default(document.querySelector('[data-acn-nav]'));
      });
    }

    if (document.querySelector('[data-acn-member-filter]')) {
      import('../AcnMemberFilter').then((AcnMemberFilter) => {
        new AcnMemberFilter.default(document.querySelector('[data-acn-member-filter]'));
      });
    }

    if (document.querySelector('[data-acn-select]')) {
      import('../AcnSelect').then((AcnSelect) => {
        document.querySelectorAll('[data-acn-select]').forEach((el) => {
          new AcnSelect.default(el);
        });
      });
    }

    if (document.querySelector('[data-acn-freelancer-filter]')) {
      import('../AcnFreelancerFilter').then((AcnFreelancerFilter) => {
        new AcnFreelancerFilter.default(document.querySelector('[data-acn-freelancer-filter]'));
      });
    }

    if (document.querySelector('[data-acn-lightbox]')) {
      import('../AcnLightbox').then((AcnLightbox) => {
        new AcnLightbox.default(document.querySelector('[data-acn-lightbox]'));
      });
    }

    if (document.querySelector('[data-acn-slider]')) {
      import('../AcnSlider').then((AcnSlider) => {
        document.querySelectorAll('[data-acn-slider]').forEach((el) => {
          new AcnSlider.default(el);
        });
      });
    }

    if (document.querySelector('iframe[data-src]')) {
      import('../AcnLazyFrame').then((AcnLazyFrame) => {
        document.querySelectorAll('iframe[data-src]').forEach((el) => {
          new AcnLazyFrame.default(el);
        });
      });
    }
  },
  finalize() {},
};
